// Global state composable
// Provides access to global store for miscellaneous global state including app context

import { useGlobalStore, APP_NAMES, type AppType } from '../stores/global.store'
import { readAmbientNuxtApp } from '../utils/ambient-nuxt-app'
import {
  isDesktop as isDesktopViewport,
  isMobile as isMobileViewport,
  isMobileOrTablet as isMobileOrTabletViewport,
  isTablet as isTabletViewport,
  isDesktopSSR,
  isMobileOrTabletSSR,
  isMobileSSR,
  isTabletSSR,
} from '../utils/core.utils'

/**
 * Access global store state and actions
 * Includes app context, theme, language, and other global state
 */
export function useGlobal() {
  const globalStore = useGlobalStore()

  return {
    // App-related state
    appType: globalStore.appType,
    isClientportal: globalStore.isClientportal,
    isGokollab: globalStore.isGokollab,
    isMeet: globalStore.isMeet,
    isCourses: globalStore.isCourses,
    isLoyaltySignup: globalStore.isLoyaltySignup,

    setAppType: globalStore.setAppType,
    isMobile: function () {
      if (process.client) {
        return isMobileViewport()
      }

      const nuxtApp = readAmbientNuxtApp()
      if (!nuxtApp) return false
      return isMobileSSR(nuxtApp as Parameters<typeof isMobileSSR>[0])
    },
    isTablet: function () {
      if (process.client) {
        return isTabletViewport()
      }

      const nuxtApp = readAmbientNuxtApp()
      if (!nuxtApp) return false
      return isTabletSSR(nuxtApp as Parameters<typeof isTabletSSR>[0])
    },
    isDesktop: function () {
      if (process.client) {
        return isDesktopViewport()
      }

      const nuxtApp = readAmbientNuxtApp()
      if (!nuxtApp) return false
      return isDesktopSSR(nuxtApp as Parameters<typeof isDesktopSSR>[0])
    },
    isMobileOrTablet: function () {
      if (process.client) {
        return isMobileOrTabletViewport() || window.innerWidth < 768
      }

      const nuxtApp = readAmbientNuxtApp()
      if (!nuxtApp) return false
      return isMobileOrTabletSSR(nuxtApp as Parameters<typeof isMobileOrTabletSSR>[0])
    },

    // Future global state will be accessible here
    // theme: globalStore.theme,
    // language: globalStore.language,
    // isLoading: globalStore.isLoading,
    // notifications: globalStore.notifications,
  }
}

/**
 * Set app type (called during app initialization)
 * Convenience function for initialization
 */
export function setAppType(type: AppType) {
  const globalStore = useGlobalStore()
  globalStore.setAppType(type)
}

// Re-export constants for convenience
export { APP_NAMES, type AppType }
